<div class="app-navigator-container app-background">
  <div class="app-navigator-query">{{ activeQuery$ | async }}</div>
  <div class="app-navigator-match">{{ resolvedMatch$ | async }}</div>
</div>